import { Button, EditableText } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as React from 'react'

import { dispatch } from '../../store'
import itemStyles from './lecture-item.scss'
import styles from './lecture-requirements.scss'

const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean,
  requirements: string[],
  lectureId: string
}

// interface IState {}

class LectureRequirements extends React.Component<IProps> {
  // public state: IState = {}

  public onRequirementListTitleChange = (title: string, id: number, requirements: string[]) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId, updated: {
        requirements: [
          ...requirements.slice(0, id),
          title,
          ...requirements.slice(id + 1),
        ]
      }
    })
  }

  public addRequirement = (requirements: string[]) => {
    const { lectureId } = this.props
    const requirement = `適合對象 ${requirements.length + 1}`
    dispatch.lectures.updateLecture({
      lectureId, updated: { requirements: [...requirements, requirement] }
    })
  }

  public deleteRequirement = (id: number, requirements: string[]) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId, updated: {
        requirements: [
          ...requirements.slice(0, id),
          ...requirements.slice(id + 1)
        ]
      }
    })
  }

  public render() {
    const { isEdit, requirements } = this.props
    return (
      <div className={cx('section')}>
        <div className={cx('section_header', { spaceBetween: true })}>
          講座需求
          <div>
            {
              // tslint:disable-next-line jsx-no-lambda
              isEdit ? <Button icon="plus" text="項目" active={true} className={cx('section_header_addButton')} onClick={() => this.addRequirement(requirements)} /> : null
            }
          </div>
        </div>
        <div className={cx('section_content')}>
          {
            requirements.map((content, id) => (
              <li key={content} className={cx('section_content_list')}>
                {
                  isEdit ? (
                    <div className={cx('section_content_list_editWrapper')}>
                      <EditableText
                        defaultValue={content}
                        placeholder="例如：無需背景，一般人就可以學習"
                        // tslint:disable-next-line jsx-no-lambda
                        onConfirm={(title: string) => this.onRequirementListTitleChange(title, id, requirements)}
                      />
                      {/* tslint:disable-next-line jsx-no-lambda */}
                      <Button icon={'trash'} text="" active={false} className={cx('section_content_list_deleteButton')} onClick={() => this.deleteRequirement(id, requirements)} />
                    </div>
                  ) : `* ${content}`
                }
              </li>
            ))
          }
        </div>
      </div>
    )
  }
}

export default LectureRequirements


// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-requirements.tsx